import { useCallback, useEffect, useState } from "react";
import { socketClient } from "../../api/socket";
import type { AdminConnection } from "../api";
import { fetchAdminConnections } from "../api";

export function useAdminLive() {
  const [connectionCount, setConnectionCount] = useState(0);
  const [connections, setConnections] = useState<AdminConnection[]>([]);
  const [pulse, setPulse] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const data = await fetchAdminConnections();
      setConnections(data);
      setConnectionCount(data.length);
    } catch {
      /* ignore polling errors */
    }
  }, []);

  useEffect(() => {
    let alive = true;

    const poll = async () => {
      try {
        const data = await fetchAdminConnections();
        if (!alive) return;
        setConnections(data);
        setConnectionCount(data.length);
      } catch {
        /* ignore polling errors */
      }
    };

    void socketClient.connect();
    void poll();

    const offCount = socketClient.on<number>("user_count", (msg) => {
      if (typeof msg.content === "number") {
        setConnectionCount(msg.content);
        setPulse((p) => p + 1);
      }
    });
    const offLogin = socketClient.on("login", () => {
      setPulse((p) => p + 1);
      void poll();
    });
    const offLogout = socketClient.on("logout", () => {
      setPulse((p) => p + 1);
      void poll();
    });

    const timer = window.setInterval(() => void poll(), 30_000);

    return () => {
      alive = false;
      offCount();
      offLogin();
      offLogout();
      window.clearInterval(timer);
    };
  }, []);

  return { connectionCount, connections, pulse, refresh };
}
